import { createContext, useContext, useMemo } from 'react';
import { createApiClient, ApiClient } from '@cleverlist/api-client';
import { useAuthStore } from '@cleverlist/store';

const ApiContext = createContext<ApiClient | null>(null);

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export function ApiProvider({ children }: { children: React.ReactNode }) {
  const { token, clearAuth } = useAuthStore();

  const api = useMemo(() => {
    const client = createApiClient(API_BASE_URL);
    client.setOnUnauthorized(() => {
      clearAuth();
    });
    return client;
  }, [clearAuth]);

  // Set token synchronously so it's available before first render/query
  api.setToken(token);

  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within an ApiProvider');
  }
  return context;
}
